import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import { Box, Dialog, Tab, Tabs, } from '@mui/material';
import SignIn from './SignIn';
import SignUp from './SignUp';
const a11yProps = (index) => ({
    id: `account-tab-${index}`,
    'aria-controls': `account-tabpanel-${index}`,
    sx: {
        backgroundColor: 'grey',
        fontWeight: 700,
        fontSize: '1.1rem',
    },
});
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (_jsx("div", { role: "tabpanel", hidden: value !== index, id: `account-tabpanel-${index}`, "aria-labelledby": `account-tab-${index}`, ...other, children: value === index && (_jsx(Box, { sx: { p: 3 }, children: children })) }));
};
const TabbedAuthDialog = ({ open, handleClose, showForgotPassword, initialTab, header, }) => {
    const [tab, setTab] = useState(initialTab === 'SIGN-IN' ? 0 : 1);
    const handleChange = (event, newValue) => {
        setTab(newValue);
    };
    return (_jsxs(Dialog, { disablePortal: true, open: open, onClose: handleClose, PaperProps: {
            sx: {
                minWidth: {
                    xs: '90%',
                    sm: '500px',
                },
            },
        }, children: [header, _jsxs(Tabs, { value: tab, onChange: handleChange, indicatorColor: "secondary", textColor: "inherit", variant: "fullWidth", "aria-label": "full width tabs example", children: [_jsx(Tab, { label: "Sign In", ...a11yProps(0), className: "siteTabs" }), _jsx(Tab, { label: "Create Account", ...a11yProps(1), className: "siteTabs" })] }), _jsx(TabPanel, { value: tab, index: 0, children: _jsx(SignIn, { display: "INLINE", handleClose: handleClose, 
                    // showSignUp={() => setTab(1)}
                    showForgotPassword: showForgotPassword }) }), _jsx(TabPanel, { value: tab, index: 1, children: _jsx(SignUp, { display: "INLINE", handleClose: handleClose, showSignIn: () => setTab(0) }) })] }));
};
TabbedAuthDialog.defaultProps = {
    initialTab: 'SIGN-IN',
    header: null,
};
export default TabbedAuthDialog;
//# sourceMappingURL=TabbedAuthDialog.js.map